export const ImportsTableColumns = [
  {
    label: 'Import created'
  },
  {
    label: 'Import updated'
  },
  {
    label: 'Created',
    width: '115px'
  },
  {
    label: 'Errors',
    width: '115px'
  }
]
